import { render, staticRenderFns } from "./teamPhysician.vue?vue&type=template&id=2fbbe6a6&scoped=true"
import script from "./teamPhysician.vue?vue&type=script&lang=js"
export * from "./teamPhysician.vue?vue&type=script&lang=js"
import style0 from "./teamPhysician.vue?vue&type=style&index=0&id=2fbbe6a6&prod&scoped=true&lang=scss"
import style1 from "./teamPhysician.vue?vue&type=style&index=1&id=2fbbe6a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbbe6a6",
  null
  
)

export default component.exports